__turbopack_export_value__({
  "body-logo-18": "WorkinHours-module-scss-module__Cil4wW__body-logo-18",
  "body-text-12": "WorkinHours-module-scss-module__Cil4wW__body-text-12",
  "body-text-14": "WorkinHours-module-scss-module__Cil4wW__body-text-14",
  "body-text-16": "WorkinHours-module-scss-module__Cil4wW__body-text-16",
  "body-text-18": "WorkinHours-module-scss-module__Cil4wW__body-text-18",
  "body-text-20": "WorkinHours-module-scss-module__Cil4wW__body-text-20",
  "body-text-24": "WorkinHours-module-scss-module__Cil4wW__body-text-24",
  "body-text-24-2": "WorkinHours-module-scss-module__Cil4wW__body-text-24-2",
  "body-text-heading-2": "WorkinHours-module-scss-module__Cil4wW__body-text-heading-2",
  "body-text-heading-3": "WorkinHours-module-scss-module__Cil4wW__body-text-heading-3",
  "body-text-medium-14": "WorkinHours-module-scss-module__Cil4wW__body-text-medium-14",
  "body-text-medium-16": "WorkinHours-module-scss-module__Cil4wW__body-text-medium-16",
  "body-text-medium-18": "WorkinHours-module-scss-module__Cil4wW__body-text-medium-18",
  "body-text-medium2-18": "WorkinHours-module-scss-module__Cil4wW__body-text-medium2-18",
  "body-text2-14": "WorkinHours-module-scss-module__Cil4wW__body-text2-14",
  "body-text2-16": "WorkinHours-module-scss-module__Cil4wW__body-text2-16",
  "button-primary-text": "WorkinHours-module-scss-module__Cil4wW__button-primary-text",
  "button-text": "WorkinHours-module-scss-module__Cil4wW__button-text",
  "button2-text": "WorkinHours-module-scss-module__Cil4wW__button2-text",
  "card-shadow": "WorkinHours-module-scss-module__Cil4wW__card-shadow",
  "effect-menu": "WorkinHours-module-scss-module__Cil4wW__effect-menu",
  "header-1": "WorkinHours-module-scss-module__Cil4wW__header-1",
  "main-container": "WorkinHours-module-scss-module__Cil4wW__main-container",
  "main-footer-container": "WorkinHours-module-scss-module__Cil4wW__main-footer-container",
  "main-header-container": "WorkinHours-module-scss-module__Cil4wW__main-header-container",
  "schedule": "WorkinHours-module-scss-module__Cil4wW__schedule",
  "schedule__day": "WorkinHours-module-scss-module__Cil4wW__schedule__day",
  "schedule__row": "WorkinHours-module-scss-module__Cil4wW__schedule__row",
  "schedule__time": "WorkinHours-module-scss-module__Cil4wW__schedule__time",
  "schedule__time_weekend": "WorkinHours-module-scss-module__Cil4wW__schedule__time_weekend",
  "title": "WorkinHours-module-scss-module__Cil4wW__title",
  "txt-12-bold": "WorkinHours-module-scss-module__Cil4wW__txt-12-bold",
  "txt-14-bold": "WorkinHours-module-scss-module__Cil4wW__txt-14-bold",
  "txt-14-bold-caps": "WorkinHours-module-scss-module__Cil4wW__txt-14-bold-caps",
  "txt-14-med": "WorkinHours-module-scss-module__Cil4wW__txt-14-med",
  "txt-16-bold": "WorkinHours-module-scss-module__Cil4wW__txt-16-bold",
  "txt-16-med": "WorkinHours-module-scss-module__Cil4wW__txt-16-med",
  "txt-18-bold": "WorkinHours-module-scss-module__Cil4wW__txt-18-bold",
  "txt-18-medium": "WorkinHours-module-scss-module__Cil4wW__txt-18-medium",
  "txt-18-medium-24": "WorkinHours-module-scss-module__Cil4wW__txt-18-medium-24",
  "txt-24-semi": "WorkinHours-module-scss-module__Cil4wW__txt-24-semi",
});
